import type { Idioma } from '../i18n';
import { capturarEscopoMfa, notificarMfa } from './mfa/ponte';
/** Cliente HTTP único. Cookie de sessão vai junto (mesma origem); erro chega como ErroApi. */
export class ErroApi extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly details?: Record<string, unknown>,
    /** lista completa de erros de domínio ({ code, message, details }) quando a API devolve várias */
    readonly erros: { code: string; message: string; details?: Record<string, unknown> }[] = [],
  ) {
    super(message);
  }
}

export async function api<T>(caminho: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const { json, headers, ...resto } = init;
  const escopoMfa = capturarEscopoMfa();
  let r: Response;
  try {
    // ROB-R4-02: sem resposta em 30 s a tela sai do "Carregando" com o erro de rede (antes ficava presa).
    r = await fetch(caminho, {
      credentials: 'same-origin',
      signal: init.signal ?? AbortSignal.timeout(30_000),
      ...resto,
      headers: { ...(json !== undefined ? { 'content-type': 'application/json' } : {}), ...headers },
      body: json !== undefined ? JSON.stringify(json) : init.body,
    });
  } catch {
    throw new ErroApi(0, 'rede', 'rede');
  }
  if (r.status === 204) return undefined as T;
  const corpo = (await r.json().catch(() => ({}))) as { code?: string; message?: string; details?: Record<string, unknown>; errors?: ErroApi['erros'] };
  if (!r.ok) {
    notificarMfa(caminho, r.status, corpo.code ?? 'erro', corpo.details, escopoMfa);
    throw new ErroApi(r.status, corpo.code ?? 'erro', corpo.message ?? r.statusText, corpo.details, corpo.errors ?? []);
  }
  return corpo as T;
}

export interface Eu {
  usuario: { id: string; nome: string; email: string; idioma: 'pt' | 'en' | 'es'; tema: 'escuro' | 'claro'; papel: string; onboardingConcluido: boolean };
  tenant_id: string;
  workspace_id: string;
  permissoes: string[];
  workspaces: { tenant_id: string; tenant_nome: string; workspace_id: string; workspace_nome: string; slug: string; sandbox: boolean }[];
  modulos?: string[];
  aparencia?: { cor: string | null; tema: 'escuro' | 'claro' | null; idioma: Idioma | null };
  /** M12.4: vazio = todas as empresas do grupo */
  empresas_permitidas?: string[];
  papel_fabrica?: string | null;
  /** SPEC2-01: o usuário já escolheu idioma ou tema (a escolha vence o padrão do workspace). */
  preferencias_definidas?: boolean;
}
